import { render, staticRenderFns } from "./TypeaheadProjects.vue?vue&type=template&id=e6df0a1a&scoped=true&"
import script from "./TypeaheadProjects.vue?vue&type=script&lang=js&"
export * from "./TypeaheadProjects.vue?vue&type=script&lang=js&"
import style0 from "./TypeaheadProjects.vue?vue&type=style&index=0&id=e6df0a1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6df0a1a",
  null
  
)

export default component.exports